export function convertDateToInternalFormat(date: string, dateformat: string) {
  const dayIndex = dateformat.indexOf("DD");
  const monthIndex = dateformat.indexOf("MM");
  const yearIndex = dateformat.indexOf("YYYY");

  return (
    date.substr(yearIndex, 4) +
    date.substr(monthIndex, 2) +
    date.substr(dayIndex, 2)
  );
}

export function getDateExtern(dateformat: string, dateInternal: string) {
  if (dateInternal) {
    const yearNr = dateInternal.substr(0, 4);
    const monthNr = dateInternal.substr(4, 2);
    const dayNr = dateInternal.substr(6, 2);

    let outDate = dateformat.replace("DD", dayNr);
    outDate = outDate.replace("MM", monthNr);
    outDate = outDate.replace("YYYY", yearNr);

    return `${outDate}`;
  } else {
    return "";
  }
}
